module.exports = __webpack_public_path__ + "img/okumidori-b.8a323e40.jpg";